var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoursIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M19.8002 12.0016C19.8002 16.6408 16.0394 20.4016 11.4002 20.4016C6.76105 20.4016 3.00024 16.6408 3.00024 12.0016C3.00024 7.36237 6.76105 3.60156 11.4002 3.60156C16.0394 3.60156 19.8002 7.36237 19.8002 12.0016Z",
    fill: "#F93749"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.0023,
    r: 6.18,
    stroke: "#F93749",
    strokeWidth: 0.84
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.0023,
    r: 9.18,
    stroke: "#F93749",
    strokeWidth: 0.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.80078V11.8008C12.0002 11.9112 12.0898 12.0008 12.2002 12.0008H15.0002",
    stroke: "#F93749",
    strokeWidth: 0.84,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30005 12.0039H4.50005",
    stroke: "#F93749",
    strokeWidth: 0.84,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 12.0039H20.7002",
    stroke: "#F93749",
    strokeWidth: 0.84,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 4.20312V3.00312",
    stroke: "#F93749",
    strokeWidth: 0.84,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 21.0039V19.8039",
    stroke: "#F93749",
    strokeWidth: 0.84,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursIcon);
export default __webpack_public_path__ + "static/media/hours-icon.442e9775670cc0ce8104f2e9111f6af1.svg";
export { ForwardRef as ReactComponent };